module.exports = __webpack_public_path__ + "img/IN.9ee50db5.jpg";